import React, {useEffect, useState} from "react";
import {Duration, Instant, LocalDateTime} from "@js-joda/core";
import {secondsToHm} from "components/pages/users-statistics-dashboard/UsersStatisticsDashboard";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";

function UserStatisticsDatatable({userSessionData, groupingType, companyFilter}: any) {

    const [tableData, setTableData] = useState<any[]>([]);

    const processData = (userSessionData, selectedType) => {
        const tempData: any[] = [];
        if (userSessionData.length > 0) {
            userSessionData.forEach((user: any) => {
                let data = tempData.find((data: any) => data.user === user[selectedType]);

                if (!data) {
                    data = {
                        user: user[selectedType],
                        activeDays: new Set(),
                        totalSessions: 0,
                        totalSessionTime: 0,
                    };
                    tempData.push(data);
                }

                if (user.from) {
                    const tempFrom = Instant.parse(user.from);
                    const tempTo = user.to ? Instant.parse(user.to) : Instant.now();
                    const sessionDuration = Duration.between(tempFrom, tempTo).seconds();

                    data.totalSessions += 1;
                    data.totalSessionTime += sessionDuration;


                    const loginDateFrom = LocalDateTime.ofInstant(tempFrom).toLocalDate().toString();
                    const loginDateTo = LocalDateTime.ofInstant(tempTo).toLocalDate().toString();

                    data.activeDays.add(loginDateFrom);
                    if (loginDateFrom !== loginDateTo) {
                        data.activeDays.add(loginDateTo);
                    }
                }
            });

            tempData.forEach((data: any) => {
                data.activeDays = data.activeDays.size;
                data.averageSessionDuration = data.totalSessionTime / data.totalSessions;
            });

            setTableData(tempData);
        }
    };

    useEffect(() => {
        processData(userSessionData, groupingType);
    }, [userSessionData, groupingType]);


    useEffect(() => {
        if (companyFilter && companyFilter.length > 0) {
            const filteredData = userSessionData.filter((user: any) => companyFilter.includes(user.companyRef));
            processData(filteredData, groupingType);
        } else {
            processData(userSessionData, groupingType);
        }
    }, [companyFilter]);

    const totalTimeBodyTemplate = (rowData: any) => {
        return secondsToHm(rowData.totalSessionTime);
    };

    const userBodyTemplate = (rowData: any) => {
        if (rowData.user) {
            return rowData.user;
        } else {
            return "No Title";
        }
    };

    const averageTimeBodyTemplate = (rowData: any) => {
        return secondsToHm(rowData.averageSessionDuration);
    };
    return (
        <div>
            <DataTable value={tableData} removableSort>
                <Column field="user" header="User" body={userBodyTemplate}/>
                <Column field="totalSessionTime" header="Total time logged in" body={totalTimeBodyTemplate} sortable/>
                <Column field="averageSessionDuration" header="Average time logged in" body={averageTimeBodyTemplate} sortable/>
                <Column field="totalSessions" header="Login count" sortable/>
                <Column field="activeDays" header="Active Days" sortable/>
            </DataTable>
        </div>
    );
}

export default UserStatisticsDatatable;